import React, { useEffect, useState } from 'react';
import { getRoleLabelsService } from '../../../../../services/company';
import DatePicker from 'react-datepicker';
import { DATE_PICKER_DATE_FORMAT } from '../../../../../constants';
import cx from 'classnames';
import { isMobile } from 'react-device-detect';
import './styles.scss';
import { convertTimeRangeTo12Hour } from '../../../../../utility';
import { useAuth } from '../../../../../container/authContext';
import DateCalendar from '../../../../../components/calendars/DateCalendar/DateCalendar';

const EmptySchedulingPeriod = ({ periodData, setFiltersData, setPeriodData, setIsEmptySchedulingPeriod }) => {
  const { user = {} } = useAuth();
  const [roleLabels, setRoleLabels] = useState({});

  useEffect(() => {
    getRoleLabelsService(user?.company?.id).then((res) => {
      setRoleLabels(res.data);
    });
  }, [user?.company?.id]);

  const handleSelectDate = (date) => {
    setPeriodData({});
    setIsEmptySchedulingPeriod(false);
    setFiltersData((prevState) => ({ ...prevState, date: date }));
  };

  return (
    <div className="table-container">
      <table border="1" cellPadding="8" cellSpacing="0" className="scheduling-table">
        <thead>
          <tr className="first-date-picker-row">
            <th colSpan="2" className="unit-info-col"></th>
            <th colSpan="3" className="date-col">
              <DateCalendar
                selected={null}
                handleChange={handleSelectDate}
                placeholderText="Select Date"
                className="form-control date-filter__input"
                withPortal={isMobile}
                wrapperClassName="first-date-picker"
                popperProps={{
                  strategy: 'fixed',
                }}
              />
            </th>
            {Array.from({ length: 13 }, (_, i) => (
              <th key={i} colSpan="3" className="date-col"></th>
            ))}
          </tr>
          <tr>
            <th colSpan="2" className="unit-info-col"></th>
            {Array.from({ length: 14 }, (_, i) => (
              <>
                <th className="shift-col-name first-in-date">{convertTimeRangeTo12Hour(periodData.shift_1)}</th>
                <th className="shift-col-name">{convertTimeRangeTo12Hour(periodData.shift_2)}</th>
                <th className="shift-col-name">{convertTimeRangeTo12Hour(periodData.shift_3)}</th>
              </>
            ))}
          </tr>
        </thead>
        <tbody>
          {periodData.units.map((unit, index) => (
            <>
              <tr className={cx('unit-row', { isMobile })} key={`${unit.name}-${unit.id}-${index}`}>
                <td rowSpan={2} className="unit-name-col">
                  {unit.name}
                </td>
                <td className="role-name-col">{roleLabels.nurse_role_label}-1</td>
                {Array.from({ length: 42 }, (_, i) => (
                  <td key={index} className={cx('shift-assignment-col')}></td>
                ))}
              </tr>
              <tr className={cx('unit-row', { isMobile })} key={`${unit.name}-${unit.id}-${index}`}>
                <td className="role-name-col">{roleLabels.cna_role_label}-1</td>
                {Array.from({ length: 42 }, (_, i) => (
                  <td key={index} className={cx('shift-assignment-col')}></td>
                ))}
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EmptySchedulingPeriod;
